export default "__VITE_ASSET__Dv7eRbPw__"